import { createSelector } from '@ngrx/store'

export const getBusinessesState = createSelector(
  (state: any) => state.businesses,
  (state: any) => state.get('list'),
)

export const getUpdateBusinessState = createSelector(
  (state: any) => state.businesses,
  (state: any) => state.get('update'),
)

export const getCreateBusinessState = createSelector(
  (state: any) => state.businesses,
  (state: any) => state.get('create'),
)

export const getImageTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('imageTypes'),
)
